import { Type } from '@angular/core';

// For routes that show change password outside IdentityRoutes, keeping it in its own lazy chunk.
export const loadChangePasswordPage = (): Promise<Type<unknown>> =>
    import('./change-password/change-password.component').then(m => m.ChangePasswordComponent);
